import { z } from 'zod';
import { laravelPaginator } from './common';

export const wireTaxonomyCategorySchema = z.looseObject({
  uid: z.string(),
  parent_uid: z.string().nullish(),
  name: z.string(),
  full_path: z.string(),
  depth: z.number(),
  taxonomy_version: z.string(),
});

export const wireTaxonomyCategoriesSchema = laravelPaginator(wireTaxonomyCategorySchema);

export interface TaxonomyCategory {
  uid: string;
  parentUid: string | null;
  name: string;
  fullPath: string;
  depth: number;
  taxonomyVersion: string;
}

export function normalizeTaxonomyCategory(
  wire: z.infer<typeof wireTaxonomyCategorySchema>,
): TaxonomyCategory {
  return {
    uid: wire.uid,
    parentUid: wire.parent_uid ?? null,
    name: wire.name,
    fullPath: wire.full_path,
    depth: wire.depth,
    taxonomyVersion: wire.taxonomy_version,
  };
}
